/**
 * Adds top level menu item in the navigation menu of an header element
 *
 * @param element
 * @return {*}
 */
export function reformatNavigationMenuItem(element) {
  if (element.children !== null && Array.isArray(element.children) && element.children.length > 0) {
    /* eslint no-param-reassign: [2, { "props": false }] */
    element.children = element.children.map((item) => {
      const newItem = { ...item };
      if (newItem.item !== null) {
        newItem.url = newItem.item.url;
      }

      return newItem;
    });

    const firstElem = element.children[0];
    if (firstElem && firstElem.item && firstElem.item.__typename === 'TaxonomyIndex' && firstElem.url === element.url) {
      element.viewAll = true;
      delete element.children[0];
    }
  }

  return element;
}
